import { TransparentRow } from './Row';
import SmallTag from './SmallTag';
import { HeaderSlide } from './headerV2/HeaderSlide';
import { useMaxWidth } from '../hooks/useResponsive';
import { getCloudinaryImageUrl } from '../utils/cloudinary';

export default function OnDemandCareBanner() {
  const isMobileDevice = useMaxWidth(1000);

  return (
    <HeaderSlide
      config={{
        bgColor: 'rgba(179, 211, 214, 0.3)',
        photoUrl: getCloudinaryImageUrl(
          'bfd559c56569abe12d3eddc10f1c3151c5c9bd8a_yf3udm.png',
          { g: 'center' }
        ),
        photoAltText: '**Sandbox Nursery**, Culver City, CA',
        title: 'Book flexible care that fits your schedule',
        description: `On-demand or regular care for your children ranging from infant to school age—Bumo adapts to your family's changing needs with comprehensive child care solutions. `,
        decors: undefined,
        mainDecor: undefined,
        cta: {
          text: 'Find child care',
          action: 'SEARCH',
        },
      }}
      mobile={isMobileDevice}
      style={{ marginVertical: 50 }}
      photoStyle={{
        margin: isMobileDevice ? 0 : 40,
        borderRadius: isMobileDevice ? 0 : 10,
        overflow: 'hidden',
      }}
      slideTextStyle={isMobileDevice && { paddingTop: 20 }}
      additionalContent={
        <TransparentRow
          style={{ justifyContent: 'flex-start', flexWrap: 'wrap', gap: 16 }}
        >
          <SmallTag title="Infant" color="#B3D3D6" />
          <SmallTag title="Toddler" color="#D0E5CC" />
          <SmallTag title="Preschool" color="#F8C1D9" />
          <SmallTag title="School age" color="#2E5394" textColor="#fff" />
        </TransparentRow>
      }
    />
  );
}
